import { Box } from "@mui/material";
import { AssessmentOutlined, CategoryOutlined, FactoryOutlined, SummarizeOutlined, WarehouseOutlined } from '@mui/icons-material';
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useMediaPredicate } from "react-media-hook";
import { TabItem } from "../../Shared/Tabs/StyledTabs";
import ReusableTabs from "../InvoiceComponents/ReusableTabs";
import WarehousesList from "./WarehousesList";
import ProductsList from "./Products/ProductsList";
import ProductCategoriesList from "./ProductCategories/ProductCategoriesList";
import ManufacturersList from "./Manufacturers/ManufacturersList";
import WarehousesReports from "./Reports/WarehousesReports";

interface WarehousesMainPageProps {
    selectedTabIndex: number;
}

export default function WarehousesMainPage(props: Readonly<WarehousesMainPageProps>) {
    const { selectedTabIndex } = props;
    const { t } = useTranslation();
    const biggerThan700 = useMediaPredicate("(min-width: 1100px)");

    const tabs = useMemo(() => [
        {
            icon: <WarehouseOutlined style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('warehouses.warehouses'),
            panel: <WarehousesList />
        },
        {
            icon: <SummarizeOutlined style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('warehouses.products'),
            panel: <ProductsList />
        },
        {
            icon: <CategoryOutlined style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('warehouses.productCategories'),
            panel: <ProductCategoriesList />
        },
        {
            icon: <FactoryOutlined style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('warehouses.manufacturers'),
            panel: <ManufacturersList />
        },
        {
            icon: <AssessmentOutlined style={{ width: biggerThan700 ? '16px' : '24px' }} />,
            label: t('warehouses.reports'),
            panel: <WarehousesReports />
        }
    ], [biggerThan700, t]);

    return (
        <Box sx={{ m: 2, maxWidth: biggerThan700 ? '100vw' : '92vw', height: 'calc(100vh - 210px)', overflowY: biggerThan700 ? 'inherit' : 'auto', p: 1 }}>
            <ReusableTabs
                variant="scrollable"
                selectedTabIndex={selectedTabIndex}
                tabs={tabs?.filter(Boolean) as TabItem[]}
            />
        </Box>
    );
}